import { createContext, useContext } from 'react';

export const SideBarContext = createContext(true);

export function useSideBar() {
  return useContext(SideBarContext);
}